import subjectFiltersSignal, {
	setSubjectFilters,
} from '@UI/Pages/Subjects/SubjectList/Filters/Signals/subjectFiltersSignal';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

const BOOLEAN_OPTIONS = [
	{ label: 'Oui', value: 'true' },
	{ label: 'Non', value: 'false' },
];

type Props = {
	readonly definition: SubjectFieldDefinitionView;
	readonly withLabel?: boolean;
};

/** Filters the list on a yes/no field; no selection means both. */
const BooleanFieldFilter: React.FC<Props> = ({ definition, withLabel = false }) => {
	const currentFilters = useSignalValue(subjectFiltersSignal);
	const value = currentFilters.valuesOf(definition.key)[0] ?? null;

	const handleChange = React.useCallback(
		(selection: string | null) => {
			setSubjectFilters(
				subjectFiltersSignal
					.peek()
					.setFieldValues(definition.key, selection === null ? [] : [selection]),
			);
		},
		[definition.key],
	);

	return (
		<Dropdown<string>
			name={`subjectField-${definition.key}`}
			label={definition.label}
			isLabelHidden={!withLabel}
			placeholder={definition.label}
			options={BOOLEAN_OPTIONS}
			optionLabel="label"
			optionValue="value"
			value={value}
			onChange={handleChange}
			showClear
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default BooleanFieldFilter;
